import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../context/AuthContext';
import { collection, getDocs, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase/config';
import AdminNotificationsCenter from './AdminNotificationsCenter';

export default function NotificationCenter() {
  // État initial avec des données de démonstration pour toujours avoir quelque chose à afficher
  const [dossiers, setDossiers] = useState([
    { id: 'demo-1', label: 'Client Démo - demo@example.com' },
    { id: 'demo-2', label: 'Entreprise Test - contact@test.com' }
  ]);
  const [users, setUsers] = useState([]);
  const [newNotif, setNewNotif] = useState({ relatedId: '', selectedUsers: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [loadingAttempted, setLoadingAttempted] = useState(false);
  const { user } = useAuth();
  
  // Fonction de création de notification
  const handleCreateNotification = useCallback(async (data) => {
    const { relatedId, selectedUsers, message } = data;
    
    if (!relatedId || selectedUsers.length === 0 || !message) {
      alert("Veuillez remplir tous les champs requis");
      return;
    }
    
    try {
      // Version simplifiée pour éviter les problèmes
      alert(`Notification créée avec succès pour le dossier: ${relatedId}`);
      
      // Décommentez ce code quand tout fonctionnera correctement
      /*
      const notification = {
        title: 'Nouvelle notification',
        message,
        relatedId,
        createdAt: serverTimestamp(),
        createdBy: user?.uid,
        participants: selectedUsers,
        readBy: [],
        replies: [],
        attachments: [],
      };
      await addDoc(collection(db, 'notifications'), notification);
      */
    } catch (err) {
      console.error("Erreur lors de la création:", err);
      alert("Erreur lors de la création de la notification");
    }
  }, [user]);
  
  // Tentative de chargement des données réelles - avec protection contre les erreurs
  useEffect(() => {
    // Éviter de lancer plusieurs tentatives de chargement
    if (loadingAttempted) return;
    
    const loadData = async () => {
      setLoadingAttempted(true);
      setLoading(true);
      
      try {
        // Tenter de charger les dossiers avec un timeout pour sécurité
        const loadDossiers = async () => {
          try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);
            
            const dossierRef = collection(db, 'dossiers');
            const dossierSnap = await getDocs(dossierRef);
            clearTimeout(timeoutId);
            
            if (dossierSnap.empty) {
              console.log("Collection de dossiers vide");
              return [];
            }
            
            return dossierSnap.docs.map(doc => {
              const data = doc.data();
              return {
                id: doc.id,
                label: `${data.clientName || 'Sans nom'} - ${data.clientEmail || 'Sans email'}`,
              };
            });
          } catch (err) {
            console.error("Impossible de charger les dossiers:", err);
            return [];
          }
        };
        
        // Exécution avec protection contre les erreurs
        const dossierList = await loadDossiers();
        
        // Si des dossiers sont chargés, les ajouter aux données de démo
        if (dossierList.length > 0) {
          setDossiers(prev => [...dossierList, ...prev]);
        }
        
      } catch (err) {
        console.error("Erreur générale:", err);
      } finally {
        setLoading(false);
      }
    };
    
    loadData();
  }, [loadingAttempted]);
  
  return (
    <div className="p-4">
      {error && (
        <div className="mb-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}
      
      {loading && (
        <div className="mb-4 p-2 bg-blue-100 border border-blue-400 text-blue-700 rounded">
          Chargement des données...
        </div>
      )}
      
      <AdminNotificationsCenter
        users={users}
        dossiers={dossiers}
        newNotif={newNotif}
        setNewNotif={setNewNotif}
        onCreate={handleCreateNotification}
      />
    </div>
  );
}